export default "__VITE_ASSET__C8U$0M3u__"